import Image from "next/image";
import Link from "next/link";
import { v4 as uuidv4 } from "uuid";
import { useRouter } from "next/router";
import {
  isChildrenPageActive,
  isParentPageActive,
} from "../../utils/daynamicNavigation";
import { useEffect, useState } from "react";
import icon from "../../components/icons/aiInterviewIcon";
import PopupForm from "../popupform";
import { wrap } from "@sentry/react";
import BotsonicWidget from "../botsonic";
import GetDemoModal from "../modal/GetDemoModal";
import { Dropdown, Menu } from "antd";

const News_item = ({
  // data,
  classes = "grid grid-cols-1 gap-[1.875rem] sm:grid-cols-1 md:grid-cols-1",
}) => {
  const [data, setData] = useState([]);
  const router = useRouter();
  const fetchData = async () => {
    try {
      const token =
        "061924da79928116f7644b9c37e2fa055271d4d1164184f345cdb67619e4dc57e7a85a9c4127088b392a5a964d840c7b928cf56d2932830376ab723424ffec16bf5f2ffbddf388d3820952ffef3db5c3e6ba9288b99c14155a04dc86ecb66953f2451395905eb789ad14dd5edd40aec7c20de007a5eb88d75dedc8e1f9b67172";
      const headers = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      };

      const url =
        "https://strapi.synthiahire.ai/api/v1/blogs?populate=*&pagination[pageSize]=1000&sort=publishedAt:desc";

      const response = await fetch(url, { headers });
      if (response.ok) {
        const responseData = await response.json();

        const blogsData = responseData.data.sort(
          (a, b) => b.updatedAt - a.updatedAt
        );
        setData(blogsData || []);
      } else {
        console.error("Request failed with status", response.status);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleButtonClick = (title, id) => {
    const formattedTitle = title.replace(/ /g, "-"); // Replace spaces with hyphens
    router.push({
      pathname: `/blog/${formattedTitle}`, // Concatenate the formatted title and id
    });
  };

  const components = {
    h1: (props) => <h1>{props.children}</h1>,
    h2: (props) => <h2>{props.children}</h2>,
    h3: (props) => <h3>{props.children}</h3>,
    h4: (props) => <h4>{props.children}</h4>,
    p: (props) => <p>{props.children}</p>,
    span: (props) => <span>{props.children}</span>,
    strong: (props) => <strong>{props.children}</strong>,
    underline: (props) => <u>{props.children}</u>,
    img: (props) => <img {...props} />,
    a: (props) => {
      if (props.href.startsWith("http")) {
        // External link, render as a normal anchor tag
        return <a href={props.href}>{props.children}</a>;
      } else {
        // Internal link, use Next.js Link to navigate to the blog/[title] page
        const title = props.href.replace("/blog/", "").replace(/-/g, " ");
        const handleClick = (e) => {
          e.preventDefault();
          router.push({
            pathname: "/blog/[title]",
            query: { title },
          });
        };

        return (
          <a href={`/blog/${title}`} onClick={handleClick}>
            {props.children}
          </a>
        );
      }
    },
  };

  return (
    <>
      <div className={classes}>
        <h3 className="text-accent">Featured</h3>
        {data.slice(0, 2).map((item) => (
          <article key={item.id}>
            <div className="rounded-2xl overflow-hidden transition-shadow hover:shadow-lg mb-2 mt-0">
              <div
                className="dark:border-jacarta-600 dark:bg-jacarta-700 border-jacarta-100 rounded-b-[1.25rem] border border-t-0 bg-white grid  my-1  grid-cols-1 lg:grid-cols-2"
                style={{ width: "800px" }}
              >
                <div className="flex justify-center">
                  <img
                    src={item.attributes.Images.data[0].attributes.url}
                    alt="synthiahire"
                    style={{ height: "120px" }}
                    className="my-5"
                  />
                </div>

                <div>
                  <h1 className="font-display text-jacarta-700 mb-4 dark:hover:text-accent hover:text-accent mb-0 text-lg dark:text-white my-4">
                    <a style={{ whiteSpace: "normal" }}>{item.attributes.Title} </a>
                  </h1>
                  {/* {item.attributes.Body.slice(0, 300)}... */}
                  <div
                    className="text-jacarta-400 flex flex-wrap items-center space-x-2 text-sm my-2 mr-2"
                    style={{ justifyContent: "right" }}
                  >
                    {/* <span>{item.attributes.createdAt?.slice(0, 10)}</span> */}
                  </div>
                  <button
                    onClick={() =>
                      handleButtonClick(item.attributes.seo.slug, item.id)
                    }
                    className="bg-accent shadow-accent-volume hover:bg-accent-dark inline-block rounded-md py-2 px-8 text-center font-semibold text-white transition-all"
                  >
                    Read More
                  </button>
                </div>
              </div>
            </div>
          </article>
        ))}
      </div>
      {/* <BotsonicWidget /> */}
    </>
  );
};

export default function Header01({ children, onGetDemo }) {
  const [toggle, setToggle] = useState(false);
  const [isCollapse, setCollapse] = useState(null);
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const handlePopupOpen = () => {
    if (onGetDemo) {
      onGetDemo();
    } else {
      setIsPopupOpen(true);
    }
  };

  const handleCloseModal = () => {
    setIsPopupOpen(false);
  };

  // window resize
  useEffect(() => {
    window.addEventListener("resize", () => {
      if (window.innerWidth >= 1024) {
        setToggle(false);
      }
    });
  });

  useEffect(() => {
    if (!(
      window.location.hostname.includes("credohire-repo-managed-staffing.vercel.app") ||
      window.location.hostname.includes("run.app") ||
      window.location.hostname.includes("localhost") ||
      window.location.hostname.includes("127.0.0.1") ||
      window.location.hostname.includes("synthiahire.ai")
    )) {

      window.location.href = `${window.location.origin}/corporate/login`;
    }
  }, []);

  const route = useRouter();
  /* -------------------------------------------------------------------------- */
  /*                            daynamic navigations                            */
  /* -------------------------------------------------------------------------- */
  const home = {
    id: 1,
    name: "Products",
    pages: {
      column1: [
        {
          id: uuidv4(),
          name: "AI Screening",
          path: "/ai-screening",
          icon: (
            <img src="https://storage.googleapis.com/credohirestorages-3/strapi-credo/assets/Screenshot_2024_10_24_174336_d22b26288c.png" height={32} width={32}></img>

          ),
          subTitle:
            "Leverage AI-powered screening to shortlist candidates for Gen AI Interviews based on custom criteria with precision and transparency",
        },

        {
          id: uuidv4(),
          name: "AI Qualification",
          path: "/ai-qualification",
          icon: (
            <img src="/images/menu-icons/qualification-icon.png" height={34} width={36}></img>

          ),
          subTitle:
            "SynthiaHire's Qualification feature uses AI and a text-based ChatBots to pre-screen candidates. ensuring efficient shortlisting based on your hiring needs",
        },



        {
          id: uuidv4(),
          name: "AI Interviews",
          path: "/ai-interviews",
          icon: (
            <img src="/images/menu-icons/videocall.png" height={32} width={32}></img>

          ),
          subTitle:
            " Utilize AI-based interviews for thorough talent assessment in specific contexts",
        },




        {
          id: uuidv4(),
          name: "Coding Round",
          path: "/coding-round",
          icon: (
            <img src="/images/menu-icons/Code.png" height={30} width={32}></img>

          ),
          subTitle:
            "Evaluate candidate’s coding skills on Integrated Development Enviornment on DSA in 10+ langugages including Python, Java, etc",
        },







      ],
      column2: [
        {
          id: uuidv4(),
          name: "Self Serve",
          path: "/self-serve",
          icon: (
            // <svg
            //   xmlns="http://www.w3.org/2000/svg"
            //   viewBox="0 0 24 24"
            //   width={24}
            //   height={24}
            //   className="h-4 w-4 fill-jacarta-700"
            // >
            //   <path fill="none" d="M0 0h24v24H0z" />
            //   <path d="M22 12.999V20a1 1 0 0 1-1 1h-8v-8.001h9zm-11 0V21H3a1 1 0 0 1-1-1v-7.001h9zM11 3v7.999H2V4a1 1 0 0 1 1-1h8zm10 0a1 1 0 0 1 1 1v6.999h-9V3h8z" />
            // </svg>
            <img src="/images/menu-icons/self-serve.png" height={32} width={32}></img>
          ),
          subTitle:
            "Enhance hiring with user-friendly tools for easy customization and navigation",
        },
        {
          id: uuidv4(),
          name: "Unified API",
          path: "/merge-api",
          icon: (
            // <svg
            //   xmlns="http://www.w3.org/2000/svg"
            //   viewBox="0 0 24 24"
            //   width={24}
            //   height={24}
            //   className="h-4 w-4 fill-jacarta-700"
            // >
            //   <path fill="none" d="M0 0h24v24H0z" />
            //   <path d="M22 12.999V20a1 1 0 0 1-1 1h-8v-8.001h9zm-11 0V21H3a1 1 0 0 1-1-1v-7.001h9zM11 3v7.999H2V4a1 1 0 0 1 1-1h8zm10 0a1 1 0 0 1 1 1v6.999h-9V3h8z" />
            // </svg>
            <img src="/images/menu-icons/merge.png" height={32} width={32}></img>
          ),
          subTitle:
            "Integrate SynthiaHire’s agentic AI technology into your ATS/HRMS with unified APIs to get started in few hours instead of days",
        },
        {
          id: uuidv4(),
          name: "APIs",
          path: "/synthiahire-api",
          icon: (
            // <svg
            //   xmlns="http://www.w3.org/2000/svg"
            //   viewBox="0 0 24 24"
            //   width={24}
            //   height={24}
            //   className="h-4 w-4 fill-jacarta-700"
            // >
            //   <path fill="none" d="M0 0h24v24H0z" />
            //   <path d="M22 12.999V20a1 1 0 0 1-1 1h-8v-8.001h9zm-11 0V21H3a1 1 0 0 1-1-1v-7.001h9zM11 3v7.999H2V4a1 1 0 0 1 1-1h8zm10 0a1 1 0 0 1 1 1v6.999h-9V3h8z" />
            // </svg>
            <img src="/images/menu-icons/api.png" height={32} width={32}></img>
          ),
          subTitle:
            "Discover APIs diversifying talent assessment capabilities for enhanced expansion",
        },

        {
          id: uuidv4(),
          name: "Marketplaces",
          path: "/marketplaces",
          icon: (
            // <svg
            //   xmlns="http://www.w3.org/2000/svg"
            //   viewBox="0 0 24 24"
            //   width={24}
            //   height={24}
            //   className="h-4 w-4 fill-jacarta-700"
            // >
            //   <path fill="none" d="M0 0h24v24H0z" />
            //   <path d="M22 12.999V20a1 1 0 0 1-1 1h-8v-8.001h9zm-11 0V21H3a1 1 0 0 1-1-1v-7.001h9zM11 3v7.999H2V4a1 1 0 0 1 1-1h8zm10 0a1 1 0 0 1 1 1v6.999h-9V3h8z" />
            // </svg>
            <img src="/images/menu-icons/marketplace-icon.png" height={38} width={34}></img>
          ),
          subTitle:
            "Listing SynthiaHire on any marketplace of ATS/HRMS is easy",
        },

      ],
    },
  };

  const page = {
    id: 2,
    name: "Solutions",
    pages: {
      column1: [
        {
          id: uuidv4(),
          name: "ICT",
          path: "/ai-interviews-for-ict",
          icon: (
            // <svg
            //   xmlns="http://www.w3.org/2000/svg"
            //   viewBox="0 0 24 24"
            //   width={24}
            //   height={24}
            //   className="h-4 w-4 fill-jacarta-700"
            // >
            //   <path fill="none" d="M0 0h24v24H0z" />
            //   <path d="M22 12.999V20a1 1 0 0 1-1 1h-8v-8.001h9zm-11 0V21H3a1 1 0 0 1-1-1v-7.001h9zM11 3v7.999H2V4a1 1 0 0 1 1-1h8zm10 0a1 1 0 0 1 1 1v6.999h-9V3h8z" />
            // </svg>
            <img src="/images/menu-icons/ict.png" height={32} width={32}></img>
          ),
          subTitle:
            "Custom ICT talent assessment ensuring perfect match for specialized roles",
        },
        {
          id: uuidv4(),
          name: "BFSI",
          path: "/ai-interviews-for-bfsi",
          icon: (
            // <svg
            //   xmlns="http://www.w3.org/2000/svg"
            //   viewBox="0 0 24 24"
            //   width={24}
            //   height={24}
            //   className="h-4 w-4 fill-jacarta-700"
            // >
            //   <path fill="none" d="M0 0h24v24H0z" />
            //   <path d="M22 12.999V20a1 1 0 0 1-1 1h-8v-8.001h9zm-11 0V21H3a1 1 0 0 1-1-1v-7.001h9zM11 3v7.999H2V4a1 1 0 0 1 1-1h8zm10 0a1 1 0 0 1 1 1v6.999h-9V3h8z" />
            // </svg>
            <img src="/images/menu-icons/bfsi.png" height={32} width={32}></img>
          ),
          subTitle:
            "Tailored BFSI assessments ensure precise matches for banking and insurance candidates",
        },
        {
          id: uuidv4(),
          name: "Retail",
          path: "/ai-interviews-for-retail",
          icon: (
            // <svg
            //   xmlns="http://www.w3.org/2000/svg"
            //   viewBox="0 0 24 24"
            //   width={24}
            //   height={24}
            //   className="h-4 w-4 fill-jacarta-700"
            // >
            //   <path fill="none" d="M0 0h24v24H0z" />
            //   <path d="M22 12.999V20a1 1 0 0 1-1 1h-8v-8.001h9zm-11 0V21H3a1 1 0 0 1-1-1v-7.001h9zM11 3v7.999H2V4a1 1 0 0 1 1-1h8zm10 0a1 1 0 0 1 1 1v6.999h-9V3h8z" />
            // </svg>
            <img src="/images/menu-icons/retail.png" height={32} width={32}></img>
          ),
          subTitle:
            "Customized assessments ensure ideal matches for roles within the Retail industry",
        },
        {
          id: uuidv4(),
          name: "Staffing Agencies",
          path: "/ai-interviews-for-staffing-agencies",
          icon: (
            // <svg
            //   xmlns="http://www.w3.org/2000/svg"
            //   viewBox="0 0 24 24"
            //   width={24}
            //   height={24}
            //   className="h-4 w-4 fill-jacarta-700"
            // >
            //   <path fill="none" d="M0 0h24v24H0z" />
            //   <path d="M22 12.999V20a1 1 0 0 1-1 1h-8v-8.001h9zm-11 0V21H3a1 1 0 0 1-1-1v-7.001h9zM11 3v7.999H2V4a1 1 0 0 1 1-1h8zm10 0a1 1 0 0 1 1 1v6.999h-9V3h8z" />
            // </svg>
            <img src="/images/menu-icons/staff.png" height={32} width={32}></img>
          ),
          subTitle:
            "Efficient tools for high-volume recruitment ensuring streamlined, specialized assessment processes",
        },
        {
          id: uuidv4(),
          name: "Universities/Colleges",
          path: "/universities-colleges",
          icon: (
            <img src="https://storage.googleapis.com/credohirestorages-3/strapi-credo/assets/college_02580e5e53.png" height={32} width={32}></img>
          ),
          subTitle:
            "Leverage our platform to validate student technical & soft skills through customized assessments, enhancing their readiness for the placements.",
        },
      ],
      column2: [
        {
          id: uuidv4(),
          name: "Volume Hiring with Agentic Calling",
          path: "/ai-interviews-volume-hiring-use-case",
          icon: (
            // <svg
            //   xmlns="http://www.w3.org/2000/svg"
            //   viewBox="0 0 24 24"
            //   width={24}
            //   height={24}
            //   className="h-4 w-4 fill-jacarta-700"
            // >
            //   <path fill="none" d="M0 0h24v24H0z" />
            //   <path d="M22 12.999V20a1 1 0 0 1-1 1h-8v-8.001h9zm-11 0V21H3a1 1 0 0 1-1-1v-7.001h9zM11 3v7.999H2V4a1 1 0 0 1 1-1h8zm10 0a1 1 0 0 1 1 1v6.999h-9V3h8z" />
            // </svg>
            <img src="https://storage.googleapis.com/credohirestorages-3/strapi-credo/assets/customer_service_8747178_15ffe4290c/customer_service_8747178_15ffe4290c.png" height={32} width={32}></img>
          ),
          subTitle:
            "Streamline high-volume hiring with AI-driven voice outreach and smart automation.",
        },
        {
          id: uuidv4(),
          name: "Equal Opportunities",
          path: "/ai-interviews-equal-opportunities-use-case",
          icon: (
            // <svg
            //   xmlns="http://www.w3.org/2000/svg"
            //   viewBox="0 0 24 24"
            //   width={24}
            //   height={24}
            //   className="h-4 w-4 fill-jacarta-700"
            // >
            //   <path fill="none" d="M0 0h24v24H0z" />
            //   <path d="M22 12.999V20a1 1 0 0 1-1 1h-8v-8.001h9zm-11 0V21H3a1 1 0 0 1-1-1v-7.001h9zM11 3v7.999H2V4a1 1 0 0 1 1-1h8zm10 0a1 1 0 0 1 1 1v6.999h-9V3h8z" />
            // </svg>
            <img src="/images/menu-icons/equal.png" height={32} width={32}></img>
          ),
          subTitle:
            "Utilize SynthiaHire's AI assessments for fair and unbiased candidate evaluations",
        },
        {
          id: uuidv4(),
          name: "Unbiased Hiring",
          path: "/ai-interviews-unbiased-hiring-use-case",
          icon: (
            // <svg
            //   xmlns="http://www.w3.org/2000/svg"
            //   viewBox="0 0 24 24"
            //   width={24}
            //   height={24}
            //   className="h-4 w-4 fill-jacarta-700"
            // >
            //   <path fill="none" d="M0 0h24v24H0z" />
            //   <path d="M22 12.999V20a1 1 0 0 1-1 1h-8v-8.001h9zm-11 0V21H3a1 1 0 0 1-1-1v-7.001h9zM11 3v7.999H2V4a1 1 0 0 1 1-1h8zm10 0a1 1 0 0 1 1 1v6.999h-9V3h8z" />
            // </svg>
            <img src="/images/menu-icons/unbiased.png" height={32} width={32}></img>
          ),
          subTitle:
            "Improve journey with our platform's friendly interface and seamless assessments",
        },
        {
          id: uuidv4(),
          name: "Candidate Experience",
          path: "/ai-interviews-candidate-experience-use-case",
          icon: (
            // <svg
            //   xmlns="http://www.w3.org/2000/svg"
            //   viewBox="0 0 24 24"
            //   width={24}
            //   height={24}
            //   className="h-4 w-4 fill-jacarta-700"
            // >
            //   <path fill="none" d="M0 0h24v24H0z" />
            //   <path d="M22 12.999V20a1 1 0 0 1-1 1h-8v-8.001h9zm-11 0V21H3a1 1 0 0 1-1-1v-7.001h9zM11 3v7.999H2V4a1 1 0 0 1 1-1h8zm10 0a1 1 0 0 1 1 1v6.999h-9V3h8z" />
            // </svg>
            <img src="/images/menu-icons/candidate_exp.png" height={32} width={32}></img>
          ),
          subTitle:
            "Accelerate hiring via AI assessments, minimizing time-to-hire while maintaining quality",
        },
        {
          id: uuidv4(),
          name: "Faster Hiring",
          path: "/ai-interviews-faster-hiring-use-case",
          icon: (
            // <svg
            //   xmlns="http://www.w3.org/2000/svg"
            //   viewBox="0 0 24 24"
            //   width={24}
            //   height={24}
            //   className="h-4 w-4 fill-jacarta-700"
            // >
            //   <path fill="none" d="M0 0h24v24H0z" />
            //   <path d="M22 12.999V20a1 1 0 0 1-1 1h-8v-8.001h9zm-11 0V21H3a1 1 0 0 1-1-1v-7.001h9zM11 3v7.999H2V4a1 1 0 0 1 1-1h8zm10 0a1 1 0 0 1 1 1v6.999h-9V3h8z" />
            // </svg>
            <img src="/images/menu-icons/faster.png" height={32} width={32}></img>
          ),
          subTitle:
            " Expedite your hiring process with efficient AI-driven assessments, reducing time-to-hire without compromising quality",
        },
      ],
    },
  };

  const explore = {
    id: 3,
    name: "Resources",
    pages: [
      {
        id: uuidv4(),
        name: "Blog",
        path: "/blog",
        icon: (
          //     <svg
          //     xmlns="http://www.w3.org/2000/svg"
          //     viewBox="0 0 24 24"
          //     width={24}
          //     height={24}
          //     className="h-4 w-4 fill-jacarta-700"
          //   >
          //     <path fill="none" d="M0 0h24v24H0z" />
          //     <path d="M22 12.999V20a1 1 0 0 1-1 1h-8v-8.001h9zm-11 0V21H3a1 1 0 0 1-1-1v-7.001h9zM11 3v7.999H2V4a1 1 0 0 1 1-1h8zm10 0a1 1 0 0 1 1 1v6.999h-9V3h8z" />
          //   </svg>
          <img src="/images/menu-icons/blog.png" height={32} width={32}></img>
        ),
      },
      {
        id: uuidv4(),
        name: "Reports",
        path: "/reports",
        icon: (
          //   <svg
          //     xmlns="http://www.w3.org/2000/svg"
          //     viewBox="0 0 24 24"
          //     width={24}
          //     height={24}
          //     className="h-4 w-4 fill-jacarta-700"
          //   >
          //     <path fill="none" d="M0 0h24v24H0z" />
          //     <path d="M22 12.999V20a1 1 0 0 1-1 1h-8v-8.001h9zm-11 0V21H3a1 1 0 0 1-1-1v-7.001h9zM11 3v7.999H2V4a1 1 0 0 1 1-1h8zm10 0a1 1 0 0 1 1 1v6.999h-9V3h8z" />
          //   </svg>
          <img src="/images/menu-icons/e-book.png" height={36} width={36}></img>
        ),
      },
      {
        id: uuidv4(),
        name: "News",
        path: "/synthiahire-in-news",
        icon: (
          <img src="/images/menu-icons/news-icon.png" height={36} width={36}></img>
        ),
      },
      {
        id: uuidv4(),
        name: "Partner-Program",
        path: "/partner-program",
        icon: (
          <img src="/images/menu-icons/partner-program-icon.png" height={36} width={36}></img>
        ),
      },
      {
        id: uuidv4(),
        name: "Affiliate Program",
        path: "/referrals",
        icon: (
          <img src="/images/menu-icons/affiliate-program-icon.png" height={36} width={36}></img>
        ),
      },

      {
        id: uuidv4(),
        name: "Events",
        path: "/events",
        icon: (
          <img src="/images/menu-icons/events-icon.png" height={36} width={36}></img>
        ),
      },


    ],
  };

  const resource = {
    id: 4,
    name: "Pricing",
    path: "/pricing",
  };

  const mobileCollapse = (id) => {
    if (isCollapse === id) {
      return setCollapse(null);
    }
    setCollapse(id);
  };

  return (
    <>
      {/* main desktop menu sart*/}
      <header className="js-page-header fixed top-0 z-30 w-full backdrop-blur transition-colors">
        <div className="flex items-center px-4 py-4 xl:px-24 ">
          <Link className="shrink-0" href="/">
            <a>
              <div className="dark:hidden">
                <Image
                  src="/images/logo.png"
                  height={52}
                  width={164}
                  alt="SynthiaHire"
                  className="max-h-7 h-auto "
                />
              </div>
              <div className="hidden dark:block">
                <Image src="/images/logo.png" height={28} width={130} alt="SynthiaHire" />
              </div>
            </a>
          </Link>
          {/* End  logo */}

          {/* End Desktop search form */}

          <div className="js-mobile-menu dark:bg-jacarta-800 invisible fixed inset-0 z-10 ml-auto items-center bg-white opacity-0 lg:visible lg:relative lg:inset-auto lg:flex lg:bg-transparent lg:opacity-100 dark:lg:bg-transparent flex-1">
            <nav className="navbar w-full">
              <ul className="flex flex-col lg:flex-row lg:items-center lg:justify-end">
                {/* nav links removed per request */}
                <li className="js-nav-dropdown group relative">
                  <button
                    onClick={() => onGetDemo && onGetDemo()}
                    className="rounded-full bg-accent text-white font-medium hover:bg-accent-dark transition-all duration-200 flex items-center justify-center py-2.5 text-sm lg:px-5"
                  >
                    <span>Get a Demo</span>
                  </button>
                </li>
                <li className="group relative ml-2 lg:px-2">
                  <button
                    type="button"
                    className="rounded-full border border-jacarta-200 text-jacarta-700 font-medium hover:border-accent hover:text-accent transition-all duration-200 flex items-center justify-center py-2.5 text-sm lg:px-5 bg-white"
                  >
                    <span>Sign In</span>
                    <svg className="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </button>
                  <ul className="invisible absolute right-0 top-[100%] z-50 min-w-[220px] translate-y-4 rounded-2xl border border-gray-100 bg-white p-3 opacity-0 shadow-2xl transition-all group-hover:visible group-hover:translate-y-2 group-hover:opacity-100">
                    <li className="mb-1">
                      <Link href="/corporate/login">
                        <a className="flex flex-col py-2 px-3 hover:bg-accent/5 rounded-lg transition-colors text-left w-full">
                          <span className="font-bold text-jacarta-700 block">Corporate Login</span>
                          <span className="text-xs text-jacarta-500 block">For employers & recruiters</span>
                        </a>
                      </Link>
                    </li>
                    <div className="my-1 border-t border-gray-100"></div>
                    <li>
                      <Link href="/candidate/login">
                        <a className="flex flex-col py-2 px-3 hover:bg-accent/5 rounded-lg transition-colors text-left w-full">
                          <span className="font-bold text-jacarta-700 block">Candidate Login</span>
                          <span className="text-xs text-jacarta-500 block">For job seekers</span>
                        </a>
                      </Link>
                    </li>
                  </ul>
                </li>
              </ul>
            </nav>

          </div>

          <div className="ml-auto flex lg:hidden">
            <button
              className="js-mobile-toggle border-jacarta-100 hover:bg-accent dark:hover:bg-accent focus:bg-accent group ml-2 flex h-10 w-10 items-center justify-center rounded-full border bg-white transition-colors hover:border-transparent focus:border-transparent dark:border-transparent dark:bg-white/[.15]"
              aria-label="open mobile menu"
              onClick={() => setToggle(true)}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width={24}
                height={24}
                className="fill-jacarta-700 h-4 w-4 transition-colors group-hover:fill-white group-focus:fill-white dark:fill-white"
              >
                <path fill="none" d="M0 0h24v24H0z" />
                <path d="M18 18v2H6v-2h12zm3-7v2H3v-2h18zm-3-7v2H6V4h12z" />
              </svg>
            </button>
          </div>
        </div>
      </header>
      <div
        className={`lg:hidden js-mobile-menu dark:bg-jacarta-800 invisible fixed inset-0 z-50 ml-auto items-center bg-white opacity-0 lg:visible lg:relative lg:inset-auto lg:bg-transparent lg:opacity-100 dark:lg:bg-transparent ${toggle ? "nav-menu--is-open" : "hidden"
          }`}
      >
        <div className="t-0 dark:bg-jacarta-800 fixed left-0 z-10 flex w-full items-center justify-between bg-white p-4 lg:hidden">
          <div className="dark:hidden">
            <Image
              src="/images/logo.png"
              height={52}
              width={164}
              alt="SynthiaHire"
              className="max-h-7 h-auto "
            />
          </div>

          <div className="hidden dark:block">
            <Image
              src={"/images/logo.png"}
              height={28}
              width={130}
              alt="SynthiaHire"
            />
          </div>

          <button
            className="js-mobile-close border-jacarta-100 hover:bg-accent focus:bg-accent group dark:hover:bg-accent ml-2 flex h-10 w-10 items-center justify-center rounded-full border bg-white transition-colors hover:border-transparent focus:border-transparent dark:border-transparent dark:bg-white/[.15]"
            onClick={() => setToggle(false)}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width={24}
              height={24}
              className="fill-jacarta-700 h-4 w-4 transition-colors group-hover:fill-white group-focus:fill-white dark:fill-white"
            >
              <path fill="none" d="M0 0h24v24H0z" />
              <path d="M12 10.586l4.95-4.95 1.414 1.414-4.95 4.95 4.95 4.95-1.414 1.414-4.95-4.95-4.95 4.95-1.414-1.414 4.95-4.95-4.95-4.95L7.05 5.636z" />
            </svg>
          </button>
        </div>
        {/* mobile menu top header content */}

        <nav className="navbar w-full">
          <ul className="flex flex-col lg:flex-row mt-20">
            <li className="js-nav-dropdown group relative">
              <button
                onClick={() => mobileCollapse(home.id)}
                className="dropdown-toggle text-jacarta-700 font-display hover:text-accent focus:text-accent dark:hover:text-accent dark:focus:text-accent flex items-center justify-between py-3.5 text-base dark:text-white lg:px-5 w-full"
              >
                <span
                  className={
                    isParentPageActive(home.pages.column1, route.asPath)
                      ? "text-accent dark:text-accent"
                      : ""
                  }
                >
                  {home.name}
                </span>
                <i className="lg:hidden">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width={24}
                    height={24}
                    className="h-4 w-4 dark:fill-white"
                  >
                    <path fill="none" d="M0 0h24v24H0z" />
                    <path d="M12 13.172l4.95-4.95 1.414 1.414L12 16 5.636 9.636 7.05 8.222z" />
                  </svg>
                </i>
              </button>

              <ul
                className={`dropdown-menu dark:bg-jacarta-800 left-0 top-[85%] z-10 min-w-[200px] gap-x-4 whitespace-nowrap rounded-xl bg-white transition-all will-change-transform group-hover:visible group-hover:opacity-100 lg:invisible lg:absolute lg:grid lg:translate-y-4 lg:py-4 lg:px-2 lg:opacity-0 lg:shadow-2xl lg:group-hover:translate-y-2 relative ${isCollapse === home.id ? "block" : "hidden"
                  }`}
              >
                Interviews
                {home?.pages?.column1.map((page) => (
                  <li key={page.id} onClick={() => setToggle(false)}>
                    <Link href={page.path}>
                      <a className="dark:hover:bg-jacarta-600 hover:text-accent focus:text-accent hover:bg-jacarta-50 flex items-center rounded-xl px-5 py-2 transition-colors justify-start">
                        <span className="bg-light-base mr-3 rounded-xl p-[0.375rem]">
                          {page.icon}
                        </span>
                        <span
                          className={`font-display ${isChildrenPageActive(route.asPath, page.path)
                            ? "text-accent dark:text-accent"
                            : "text-jacarta-700"
                            } text-sm dark:text-white`}
                        >
                          {page.name}
                        </span>
                        {page.condition ? (
                          <span className="rounded bg-green py-1 px-2 text-tiny font-bold uppercase leading-none text-white ml-4">
                            new
                          </span>
                        ) : undefined}
                      </a>
                    </Link>
                  </li>
                ))}
                Implementation
                {home?.pages?.column2.map((page) => (
                  <li key={page.id} onClick={() => setToggle(false)}>
                    <Link href={page.path}>
                      <a className="dark:hover:bg-jacarta-600 hover:text-accent focus:text-accent hover:bg-jacarta-50 flex items-center rounded-xl px-5 py-2 transition-colors justify-start">
                        <span className="bg-light-base mr-3 rounded-xl p-[0.375rem]">
                          {page.icon}
                        </span>
                        <span
                          className={`font-display ${isChildrenPageActive(route.asPath, page.path)
                            ? "text-accent dark:text-accent"
                            : "text-jacarta-700"
                            } text-sm dark:text-white`}
                        >
                          {page.name}
                        </span>
                        {page.condition ? (
                          <span className="rounded bg-green py-1 px-2 text-tiny font-bold uppercase leading-none text-white ml-4">
                            new
                          </span>
                        ) : undefined}
                      </a>
                    </Link>
                  </li>
                ))}
              </ul>
            </li>
            <li className="js-nav-dropdown group relative">
              <button
                onClick={() => mobileCollapse(page.id)}
                className="dropdown-toggle text-jacarta-700 font-display hover:text-accent focus:text-accent dark:hover:text-accent dark:focus:text-accent flex items-center justify-between py-3.5 text-base dark:text-white lg:px-5 w-full"
              >
                <span
                  className={
                    isParentPageActive(page.pages.column1, route.asPath)
                      ? "text-accent dark:text-accent"
                      : ""
                  }
                >
                  {page.name}
                </span>
                <i className="lg:hidden">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width={24}
                    height={24}
                    className="h-4 w-4 dark:fill-white"
                  >
                    <path fill="none" d="M0 0h24v24H0z" />
                    <path d="M12 13.172l4.95-4.95 1.414 1.414L12 16 5.636 9.636 7.05 8.222z" />
                  </svg>
                </i>
              </button>
              <ul
                className={`dropdown-menu left-0 top-[85%] z-10 grid-flow-row grid-cols-[repeat(2,_1fr)] gap-x-4 whitespace-nowrap rounded-xl bg-white transition-all will-change-transform group-hover:visible group-hover:opacity-100 dark:bg-jacarta-800 lg:invisible lg:absolute lg:!grid lg:translate-y-4 lg:py-8 lg:px-2 lg:opacity-0 lg:shadow-2xl lg:group-hover:translate-y-2 relative ${isCollapse === page.id ? "block" : "hidden"
                  }`}
              >
                Industry
                {page?.pages?.column1.map((page) => (
                  <li key={page.id} onClick={() => setToggle(false)}>
                    <Link href={page.path}>
                      <a className="dark:hover:bg-jacarta-600 hover:text-accent focus:text-accent hover:bg-jacarta-50 flex items-center rounded-xl px-5 py-2 transition-colors justify-start">
                        <span className="bg-light-base mr-3 rounded-xl p-[0.375rem]">
                          {page.icon}
                        </span>
                        <span
                          className={
                            isChildrenPageActive(page.path, route.asPath)
                              ? "text-accent dark:text-accent"
                              : ""
                          }
                        >
                          {page.name}
                        </span>
                        {page.condition ? (
                          <span className="rounded bg-green py-1 px-2 text-tiny font-bold uppercase leading-none text-white ml-4">
                            new
                          </span>
                        ) : undefined}
                      </a>
                    </Link>
                  </li>
                ))}
                Use Cases
                {page?.pages?.column2.map((page) => (
                  <li key={page.id} onClick={() => setToggle(false)}>
                    <Link href={page.path}>
                      <a className="dark:hover:bg-jacarta-600 hover:text-accent focus:text-accent hover:bg-jacarta-50 flex items-center rounded-xl px-5 py-2 transition-colors justify-start">
                        <span className="bg-light-base mr-3 rounded-xl p-[0.375rem]">
                          {page.icon}
                        </span>
                        <span
                          className={
                            isChildrenPageActive(page.path, route.asPath)
                              ? "text-accent dark:text-accent"
                              : ""
                          }
                        >
                          {page.name}
                        </span>
                        {page.condition ? (
                          <span className="rounded bg-green py-1 px-2 text-tiny font-bold uppercase leading-none text-white ml-4">
                            new
                          </span>
                        ) : undefined}
                      </a>
                    </Link>
                  </li>
                ))}
              </ul>
            </li>
            <li className="js-nav-dropdown nav-item dropdown group relative">
              <button
                onClick={() => mobileCollapse(explore.id)}
                className="dropdown-toggle text-jacarta-700 font-display hover:text-accent focus:text-accent dark:hover:text-accent dark:focus:text-accent flex items-center justify-between py-3.5 text-base dark:text-white lg:px-5 w-full"
              >
                <span
                  className={
                    isParentPageActive(explore.pages, route.asPath)
                      ? "text-accent dark:text-accent"
                      : ""
                  }
                >
                  {explore.name}
                </span>
                <i className="lg:hidden">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width={24}
                    height={24}
                    className="h-4 w-4 dark:fill-white"
                  >
                    <path fill="none" d="M0 0h24v24H0z" />
                    <path d="M12 13.172l4.95-4.95 1.414 1.414L12 16 5.636 9.636 7.05 8.222z" />
                  </svg>
                </i>
              </button>
              <ul
                className={`dropdown-menu left-0 top-[85%] z-10 grid-flow-row grid-cols-[repeat(2,_1fr)] gap-x-4 whitespace-nowrap rounded-xl bg-white transition-all will-change-transform group-hover:visible group-hover:opacity-100 dark:bg-jacarta-800 lg:invisible lg:absolute lg:!grid lg:translate-y-4 lg:py-8 lg:px-2 lg:opacity-0 lg:shadow-2xl lg:group-hover:translate-y-2 relative ${isCollapse === explore.id ? "block" : "hidden"
                  }`}
                aria-labelledby="navDropdown-1"
              >
                {explore?.pages?.map((page) => (
                  <li key={page.id} onClick={() => setToggle(false)}>
                    <Link href={page.path}>
                      <a className="dark:hover:bg-jacarta-600 hover:text-accent focus:text-accent hover:bg-jacarta-50 flex items-center rounded-xl px-5 py-2 transition-colors">
                        <span className="bg-light-base mr-3 rounded-xl p-[0.375rem]">
                          {page.icon}
                        </span>
                        <span className="font-display text-jacarta-700 text-sm dark:text-white">
                          {page.name}
                        </span>
                      </a>
                    </Link>
                  </li>
                ))}
              </ul>
            </li>
            <li className="js-nav-dropdown group relative">
              <Link href={resource.path}>
                <button
                  onClick={() => mobileCollapse(resource.id)}
                  className="dropdown-toggle text-jacarta-700 font-display hover:text-accent focus:text-accent dark:hover:text-accent dark:focus:text-accent flex items-center justify-between py-3.5 text-base dark:text-white lg:px-5 w-full"
                >
                  <span
                    className={
                      isParentPageActive([], route.asPath)
                        ? "text-accent dark:text-accent"
                        : ""
                    }
                  >
                    {resource.name}
                  </span>
                  {/* <i className="lg:hidden">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width={24}
                    height={24}
                    className="h-4 w-4 dark:fill-white"
                  >
                    <path fill="none" d="M0 0h24v24H0z" />
                    <path d="M12 13.172l4.95-4.95 1.414 1.414L12 16 5.636 9.636 7.05 8.222z" />
                  </svg>
                </i> */}
                </button>
              </Link>
              {/* <ul
                className={`dropdown-menu left-0 top-[85%] z-10 grid-flow-row grid-cols-[repeat(2,_1fr)] gap-x-4 whitespace-nowrap rounded-xl bg-white transition-all will-change-transform group-hover:visible group-hover:opacity-100 dark:bg-jacarta-800 lg:invisible lg:absolute lg:!grid lg:translate-y-4 lg:py-8 lg:px-2 lg:opacity-0 lg:shadow-2xl lg:group-hover:translate-y-2 relative ${
                  isCollapse === resource.id ? "block" : "hidden"
                }`}
                aria-labelledby="navDropdown-4"
              >
                {resource?.pages?.map((page) => (
                  <li key={page.id} onClick={() => setToggle(false)}>
                    <Link href={page.path}>
                      <a className="dark:hover:bg-jacarta-600 hover:text-accent focus:text-accent hover:bg-jacarta-50 flex items-center rounded-xl px-5 py-2 transition-colors">
                        <span
                          className={`font-display text-jacarta-700 text-sm dark:text-white ${
                            isChildrenPageActive(page.path, route.asPath)
                              ? "text-accent dark:text-accent"
                              : ""
                          }`}
                        >
                          {page.name}
                        </span>
                      </a>
                    </Link>
                  </li>
                ))}
              </ul> */}
            </li>
          </ul>
        </nav>
        {/* End navbar mobile menu  */}

        <div className="mt-10 w-full px-4 space-y-4 lg:hidden">
          <button
            onClick={() => {
              onGetDemo && onGetDemo();
              setToggle(false);
            }}
            className="w-full rounded-full bg-accent text-white font-medium hover:bg-accent-dark transition-all duration-200 py-3 text-center"
          >
            Get a Demo
          </button>
          <div className="flex flex-col space-y-2 pt-4 border-t border-jacarta-100">
            <Link href="/corporate/login">
              <a onClick={() => setToggle(false)} className="flex items-center justify-between p-4 bg-gray-50 rounded-xl">
                <div className="flex flex-col">
                  <span className="font-bold text-jacarta-700">Corporate Login</span>
                  <span className="text-xs text-jacarta-500">For employers</span>
                </div>
                <svg className="w-5 h-5 text-jacarta-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </a>
            </Link>
            <Link href="/candidate/login">
              <a onClick={() => setToggle(false)} className="flex items-center justify-between p-4 bg-gray-50 rounded-xl">
                <div className="flex flex-col">
                  <span className="font-bold text-jacarta-700">Candidate Login</span>
                  <span className="text-xs text-jacarta-500">For job seekers</span>
                </div>
                <svg className="w-5 h-5 text-jacarta-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </a>
            </Link>
          </div>
        </div>
      </div>
      {/* End mobile menu and it's other materials */}
      {children}

      {isPopupOpen && <PopupForm closeModal={handleCloseModal} />}
      {/* <BotsonicWidget /> */}
    </>
  );
}